export default "__VITE_ASSET__9e1e4382__"